export default "__VITE_ASSET__D8Duc65y__"